import APIError from './api.error';

export default class APIUnauthorizedError extends APIError {
    constructor(
        message: string,
        code?: string,
        status?: number,
        target?: string,
        details?: unknown,
        innerError?: unknown,
        cause?: Error
    ) {
        const theCode = code || 'EDF:APIUnauthorizedError';
        super(message, theCode, status, target, details, innerError, cause);
    }
}
